import * as SDK from "azure-devops-extension-sdk";
// Service id string is stable; the azure-devops-extension-api package exports it
// as CommonServiceIds.HostPageLayoutService. Inlined to avoid the extra dep.
const HOST_PAGE_LAYOUT_SERVICE = "ms.vss-features.host-page-layout-service";
const HOST_NAVIGATION_SERVICE = "ms.vss-features.host-navigation-service";
const WORK_ITEM_FORM_SERVICE = "ms.vss-work-web.work-item-form-service";
/**
 * getService() for a service the current page doesn't host is not guaranteed to
 * reject — it can simply never settle, which would hang execute() before the
 * dialog ever opens. Anything optional goes through here.
 */
function withTimeout(p, ms) {
    return Promise.race([
        p,
        new Promise((resolve) => setTimeout(() => resolve(undefined), ms)),
    ]);
}
/**
 * Each menu target hands us a differently shaped actionContext, and the docs
 * don't pin the field names down. Try the known shapes, then fall back to the
 * work item form service (only present when the form is open). Everything is
 * optional — no id just means the dialog opens empty.
 */
async function findWorkItemId(ctx) {
    const candidate = ctx?.workItemId ?? ctx?.id ?? ctx?.workItemIds?.[0] ?? ctx?.ids?.[0] ?? ctx?.["System.Id"];
    if (typeof candidate === "number")
        return candidate;
    if (typeof candidate === "string" && /^\d+$/.test(candidate))
        return Number(candidate);
    try {
        const form = await withTimeout(SDK.getService(WORK_ITEM_FORM_SERVICE), 1000);
        return form ? await withTimeout(form.getId(), 1000) : undefined;
    }
    catch {
        return undefined; // not on a work item form
    }
}
const handler = () => ({
    // actionContext is whatever the menu target hands us. Used only as hints —
    // the dialog works fine without any of it.
    execute: async (actionContext) => {
        // The action runs in a hidden iframe. An unhandled rejection here is
        // invisible — the menu item just does nothing — so surface it.
        try {
            // Built from the parts rather than getExtensionContext().id, which is
            // ambiguous about whether it's already qualified. openCustomDialog is a
            // no-op on an unknown id, so this must be publisher.extension.contribution.
            const ctx = SDK.getExtensionContext();
            const dialogId = `${ctx.publisherId}.${ctx.extensionId}.create-branch-dialog`;
            console.log("[custom-branch] extension context", ctx);
            console.log("[custom-branch] opening dialog", dialogId, "context", actionContext);
            const workItemId = await findWorkItemId(actionContext);
            const layout = await SDK.getService(HOST_PAGE_LAYOUT_SERVICE);
            console.log("[custom-branch] layout service", !!layout, "workItemId", workItemId);
            layout.openCustomDialog(dialogId, {
                title: "New branch",
                lightDismiss: false,
                configuration: {
                    repositoryId: actionContext?.repository?.id ?? actionContext?.repositoryId,
                    sourceRef: actionContext?.ref?.name ?? actionContext?.refName,
                    workItemId,
                },
                onClose: async (result) => {
                    if (!result?.url)
                        return;
                    // window.open(url, "_top") is blocked here: the action frame is
                    // cross-origin (gallerycdn) and the click happened in the dialog
                    // frame, so this frame has no user activation. Navigate via the host.
                    const nav = await SDK.getService(HOST_NAVIGATION_SERVICE);
                    nav.navigate(result.url);
                },
            });
        }
        catch (e) {
            console.error("[custom-branch] execute failed", e);
            alert(`Custom Branch Creator failed:\n\n${e instanceof Error ? e.stack : e}`);
        }
    },
});
// getContributionId() throws until the init handshake lands, so registration
// has to wait for it. The host only invokes execute() on click — long after.
SDK.init()
    .then(() => SDK.register(SDK.getContributionId(), handler))
    .catch((e) => console.error("[custom-branch] init failed", e));
